var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"live-user",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"live-dot"}),_vm._v(" "+_vm._s(_vm.getUserName(_vm.item)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }